import React from 'react';
import {useHistory} from 'react-router-dom';
import './Header.sass';
import HeaderJsx from './Header.jsx';

function Header(props) {
  const history = useHistory();
  const logout = () => {
    localStorage.removeItem('jwt');
    history.push('/')
  }

  return(
      <HeaderJsx
      logout={logout}
      active={props.active}
      />
  )
}

export default Header;
